import React from 'react';

type Props = {

}


export default function MainMenu_ChatsLoading(props: Props) {
    return (
        <div className="ui5-txt-not-important m-l-20">
            Loading...
        </div>
    );
}